import { createContext } from 'react';

const ArchivesPageManagerContext = createContext();

export default ArchivesPageManagerContext;
